<template>
  <page-edicion :fluid="false">
    <page-header :title="motivo.nombre" subtitle="Motivo de cierre" back-to="/motivosCierreOferta"></page-header>
    <formulario-motivo :motivo="motivo" />
  </page-edicion>
</template>
<script>
import FormularioMotivo from "./FormularioMotivo.vue";

export default {
  components: { FormularioMotivo },
  data() {
    return {
      motivo: {},
    };
  },
  async mounted() {
    const response = await this.$backend.get("/motivosCierreOferta/cargar&id=" + this.$route.params.id);
    this.motivo = response.data;
  },
};
</script>
